import { BitrixVue } from 'ui.vue';
/* кодировка ютв-8 */
BitrixVue.component('DoorItem', {
	data() {
		return {
			selectedSize: 0,
			selectDoor: null,
		};
	},
	props: ['state', 'image', 'title', 'price', 'availability', 'activeDoor', 'doorId'],
	updated() {
		if (this.activeDoor !== this.doorId) {
			this.selectedSize = 0;
		}
		this.setDoorSize(this.selectedSize);
	},
	methods: {
		setDoorSize(index) {
			this.selectedSize = index;
			this.$emit('setDoorSize', this.selectedSize);
		},
		maxPrice(list) {
			let maxPrice = 0;
			if (list && list !== null && list.length) {
				maxPrice = list.reduce((a, b) => (a > Number(b.price) ? a : Number(b.price)), Number(list[0].price));
			}

			return maxPrice;
		},
		minPrice(list) {
			let minPrice = 0;
			if (list && list !== null && list.length) {
				minPrice = list.reduce((a, b) => (a < Number(b.price) ? a : Number(b.price)), Number(list[0].price));
			}
			return minPrice;
		},
	},
	template: ` <div class="config-slider__item" @click="$emit('setActive')">
	<div class="config-slider__item-top">
		<div class="config-slider__img-pad">
			<div class="config-slider__selection"></div>
			<img :src="image" :alt="title">
		</div>
		<div class="config-slider__title">{{title}}</div>
	</div>
	<div class="config-slider__item-bottom">
		<div class="config-slider__info">
			<div class="config-slider__price">{{price}} руб</div>
		</div>
	</div>
	</div>
	`,
});
